// Selecionar e associar eventos ao formulário de busca
export function setupSearchModel() {
  const searchModel = document.getElementById('searchModel');
  searchModel.addEventListener('submit', handleSearchSubmit);
}

function handleSearchSubmit(event) {
  event.preventDefault();
  const buscaInput = document.getElementById('busca');
  const kmMinInput = document.getElementById('km_min');
  const kmMinMaskedInput = document.getElementById('km_min_masked');
  const kmMaxInput = document.getElementById('km_max');
  const kmMaxMaskedInput = document.getElementById('km_max_masked');

  setupHiddenSearchInput();
  // applyLoader();
  fetchFilteredCars({
    busca: buscaInput.value,
    km_min: kmMinInput.value,
    km_min_masked: kmMinMaskedInput.value,
    km_max: kmMaxInput.value,
    km_max_masked: kmMaxMaskedInput.value
  });
}

function fetchFilteredCars(filters) {
  $.request('onGetFilteredCars', {
      data: filters,
      success: function (data) {
          renderResults(data);
          removeLoader();
          updateUrlWithFilters();
      },
      complete: () => {
          // Placeholder para ações futuras
      }
  });
}

function renderResults(data) {
  const listCars = $('#listCars');
  const pagination = $('#pagination');
  const totalCars = $('#totalCars');

  const markupListCars = data["#listCars"] ?? `
    <section class="empty-stock py-5">
      <div class="container">
        <div class="col-12 d-flex justify-content-center">
          <h1 class="page-title">Não encontramos nenhum veículo para os filtros selecionados.</h1>
        </div>
      </div>
    </section>
  `;
  const markupPagination = data["#pagination"] ?? '';
  const markupTotalCars = data["#totalCars"] ?? '';

  listCars.html(markupListCars);
  pagination.html(markupPagination);
  totalCars.html(markupTotalCars);
  setupPaginationLinks();
}

// Inicialização ao carregar o documento
export function initialFetchFilteredCars() {
  const inputBusca = $('#busca');
  const urlParams = new URLSearchParams(window.location.search);
  const buscaUrl = urlParams.get('busca');
  if (buscaUrl) {
    inputBusca.val(buscaUrl);
  }
  
  const buscaVal = $('#busca').val();
  if (buscaVal) fetchFilteredCars({ busca: buscaVal });
  
  setupPaginationLinks();
  window.addEventListener('onFiltersLoaded', handleFiltersLoaded);
}

function handleFiltersLoaded(event) {
  showKmPricePlaceholder();
  maskBigNumber(['#price_min', '#price_max', '#km_min', '#km_max']);
  setupHiddenSearchInput();
}

function setupHiddenSearchInput() {
  const searchModelInput = document.querySelector('input#busca');
  const formFilterCars = document.getElementById('form-filter-cars');
  const buscaInput = document.createElement('input');
  buscaInput.setAttribute('type', 'hidden');
  buscaInput.setAttribute('name', 'busca');
  buscaInput.setAttribute('id', 'buscaFilter');
  buscaInput.setAttribute('value', searchModelInput.value);
  formFilterCars.appendChild(buscaInput);

  buscaInput.value = searchModelInput.value;

  searchModelInput.addEventListener('change', function (event) {
      const buscaInput = document.getElementById('buscaFilter');
      buscaInput.value = event.target.value;
  });
}

function maskBigNumber(elementsIds) {
  elementsIds.forEach(function (elementId) {
      const originalElement = document.querySelector(elementId);
      const maskedElementId = `${elementId}_masked`;
      const maskedElement = document.querySelector(maskedElementId);

      if(maskedElement){
        maskedElement.addEventListener('keyup', function (e) {
            let newValue = e.target.value;
            newValue = newValue.replace(/\D/g, '');
            newValue = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            e.target.value = newValue;
            originalElement.value = newValue.replace(/\./g, '');
        });
      }
  });
}

function showKmPricePlaceholder() {
  addPlaceholderForElements('#km_min_masked', '#km_max_masked', '#card-kmText .card-body div', 'km-container');
  addPlaceholderForElements('#price_min_masked', '#price_max_masked', '#card-priceText .card-body div', 'price-container');
}

function addPlaceholderForElements(elementId1, elementId2, containerSelector, containerClass) {
  const elements = [$(elementId1), $(elementId2)];
  let containersContent = '';

  elements.forEach(function (element) {
      const newElement = document.createElement('div');
      newElement.classList.add(containerClass);
      element.appendTo(newElement);
      containersContent += newElement.outerHTML;
  });

  $(containerSelector).append(containersContent);
}

export function setupConditionCheckboxes() {
  window.addEventListener('onFiltersLoaded', function () {
      const checkboxes = {
          all: document.getElementById('condition-all'),
          new: document.getElementById('condition-new'),
          used: document.getElementById('condition-used')
      };
      const kmMinInput = document.getElementById('km_min');
      const kmMinMaskedInput = document.getElementById('km_min_masked');
      const kmMaxInput = document.getElementById('km_max');
      const kmMaxMaskedInput = document.getElementById('km_max_masked');

      Object.keys(checkboxes).forEach(key => {
          checkboxes[key]?.addEventListener('click', function () {
              handleCheckboxClick(key, checkboxes, kmMinMaskedInput, kmMaxMaskedInput, kmMinInput, kmMaxInput);
          });
      });

      checkUrlParams(checkboxes);
  });
}

function handleCheckboxClick(clickedKey, checkboxes, kmMinInput, kmMaxInput, kmMinMaskedInput, kmMaxMaskedInput) {
  Object.keys(checkboxes).forEach(key => {
      if (key !== clickedKey) {
          checkboxes[key].checked = false;
      }
  });
  updateFormForCheckbox(clickedKey, kmMinInput, kmMaxInput, kmMinMaskedInput, kmMaxMaskedInput);
}

function updateFormForCheckbox(checkboxKey, kmMinInput, kmMaxInput, kmMinMaskedInput, kmMaxMaskedInput) {
  switch (checkboxKey) {
      case 'all':
          kmMinInput.value = '';
          kmMinMaskedInput.value = '';
          kmMaxInput.value = '';
          kmMaxMaskedInput.value = '';
          break;
      case 'new':
          kmMinInput.value = '';
          kmMinMaskedInput.value = '';
          kmMaxInput.value = '1';
          kmMaxMaskedInput.value = '1';
          break;
      case 'used':
          kmMinInput.value = '1';
          kmMinMaskedInput.value = '1';
          kmMaxInput.value = '';
          kmMaxMaskedInput.value = '';
          break;
  }

  // applyLoader();
  const paginationInput = document.getElementById('pagination-used-input');
  if (paginationInput) {
      paginationInput.value = 1;
  }

  const busca = document.getElementById('busca').value;
  fetchFilteredCars({
    km_min: kmMinInput.value,
    km_min_masked: kmMinMaskedInput.value,
    km_max: kmMaxInput.value,
    km_max_masked: kmMaxMaskedInput.value,
    busca: busca,
    page: 1
  });
}

function checkUrlParams(checkboxes) {
  const urlParams = new URLSearchParams(window.location.search);
  const kmMaxMasked = urlParams.get('km_max_masked');

  if (kmMaxMasked === null || kmMaxMasked === '0') {
      if (checkboxes.all) checkboxes.all.checked = true;
  } else if (kmMaxMasked === '1') {
      if (checkboxes.new) checkboxes.new.checked = true;
  } else if (parseInt(kmMaxMasked) > 1) {
      if (checkboxes.used) checkboxes.used.checked = true;
  }
}

// Funções de Loader
function applyLoader() {
  const skeletonCardModel = document.getElementById('skeleton-card-model');
  const listCars = document.getElementById('listCars');
  listCars.innerHTML = generateSkeletonCards(12, skeletonCardModel.innerHTML);
  $('#listCars').css('filter', 'blur(5px)');
}

function removeLoader() {
  $('#listCars').css('filter', 'none');
}

function generateSkeletonCards(count, skeletonHTML) {
  return new Array(count).fill(skeletonHTML).join('');
}

// Adicionar eventos para links de paginação
function setupPaginationLinks() {
  $(document).off('click', '.page-link', applyLoader);
  $(document).on('click', '.page-link', function() {
      
    // applyLoader();
  });
}

// Atualizar o URL de acordo com filtros
function updateUrlWithFilters() {
  updateURLPage();
  updateURLSearch();
}

function updateURLPage() {
  const paginationInput = document.getElementById('pagination-used-input');
  const url = new URL(window.location.href);

  if (!paginationInput || paginationInput.value === '1') {
      url.searchParams.delete('page');
  } else {
      url.searchParams.set('page', paginationInput.value);
  }

  window.history.replaceState({}, '', url.toString());
}

function updateURLSearch() {
  const buscaFilterInput = document.getElementById('buscaFilter');
  const buscaInput = document.getElementById('busca');

  const url = new URL(window.location.href);

  let buscaValue = '';
  if (buscaFilterInput && buscaFilterInput.value) {
      buscaValue = buscaFilterInput.value;
  } else if (buscaInput && buscaInput.value) {
      buscaValue = buscaInput.value;
  }

  if (buscaValue !== '') {
      url.searchParams.set('busca', buscaValue);
  } else {
      url.searchParams.delete('busca');
  }

  window.history.replaceState({}, '', url.toString());
}


export function agreeTermsBtnClickListener(){
  const agreeTermsBtn = document.querySelector('#agree-terms');
  const inputAgreeTerms = document.querySelectorAll('input[name="termos"]');
  
  if(agreeTermsBtn) { 
    agreeTermsBtn.addEventListener('click', () => {
      inputAgreeTerms.forEach((input) => {
        input.checked = true;
      });
    }); 
  }
}